import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import * as WifiInformationActions from '../actions/wifi-information.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IEntity } from '@proximus/entity-manager';
import {
  TechnicalError,
  WifiInformationModel,
} from '@dch/products-business-logic';
import { WifiInformationService } from '../../services/wifi-information.service';

@Injectable({
  providedIn: 'root',
})
export class WifiInformationEffects {
  @Effect()
  wifiInformation$: Observable<Action> = this.actions$.pipe(
    ofType(WifiInformationActions.GET_WIFI_INFORMATION),
    switchMap((action: WifiInformationActions.GetWifiInformation) =>
      this.wifiInformationService.getWifiInformation(action.payload).pipe(
        map(
          (entity: IEntity<WifiInformationModel>) =>
            new WifiInformationActions.GetWifiInformationSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new WifiInformationActions.GetWifiInformationFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private wifiInformationService: WifiInformationService,
  ) {}
}
